<template>
    <div class="sigWrapper mt-5" :style="wrapperStyles">
        <font-awesome-icon :icon="['fal', 'edit']"></font-awesome-icon>
        <span class="line"></span>
        <VueSignaturePad
            ref="pad"
            :custom-style="styles"
            :height="height"
            :options="options"
            :width="width"
            :class="{ 'sig-disabled': disabled }"
        />
        <a v-on:click="clear" class="clear-button">Clear</a>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
            },

            height: {
                type: String,
                default: "140px",
            },

            width: {
                type: String,
                default: "100%",
            },

            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                options: {
                    onBegin: this.onBegin,
                    onEnd: this.onEnd,
                    penColor: "#008ad8",
                    throttle: 20,
                    velocityFilterWeight: 0.7,
                },

                styles: {
                    border: "solid 1px #A7ADB0",
                    marginLeft: "6px",
                    background: "#F2F3F4",
                    borderRadius: "4px",
                },
            }
        },

        computed: {
            wrapperStyles() {
                return {
                    width: `calc(${this.width} - 7px)`,
                }
            },
        },

        methods: {
            clear() {
                this.$refs.pad.clearSignature()
                this.$emit("input", null)
                this.$emit("signature-valid", false)
            },

            onBegin() {},
            onEnd() {
                const pngData = this.$refs.pad.saveSignature("image/png").data
                // Converting Image to grayscale and saving on application
                const hiddenCanvas = document.createElement("canvas")
                const ratio = Math.max(window.devicePixelRatio || 1, 1)
                hiddenCanvas.width = this.$refs.pad.$refs.signaturePadCanvas.offsetWidth * ratio
                hiddenCanvas.height = this.$refs.pad.$refs.signaturePadCanvas.offsetHeight * ratio
                const hiddenCtx = hiddenCanvas.getContext("2d")
                const image = new Image()
                image.src = pngData
                const that = this
                image.onload = function () {
                    hiddenCtx.drawImage(image, 0, 0)
                    let imgData = hiddenCtx.getImageData(0, 0, hiddenCtx.canvas.width, hiddenCtx.canvas.height)
                    for (let i = 0; i < imgData.data.length; i += 4) {
                        let count = imgData.data[i] + imgData.data[i + 1] + imgData.data[i + 2]

                        // Default background to white
                        let colour = 255
                        if (count > 510) colour = 255
                        else if (count > 255) colour = 127.5
                        imgData.data[i] = colour
                        imgData.data[i + 1] = colour
                        imgData.data[i + 2] = colour
                        imgData.data[i + 3] = 255
                    }
                    hiddenCtx.putImageData(imgData, 0, 0)
                    that.$emit("input", hiddenCanvas.toDataURL("image/png"))
                    that.$emit("signature-valid", pngData.length > 3000)
                }
            },
        },
    }
</script>

<style lang="scss">
    .sigWrapper {
        position: relative;
        transform: translateX(-4px);
        width: 570px;

        .fa-edit {
            position: absolute;
            bottom: 62px;
            left: 24px;
            width: 30px;
            height: 27px;
            color: #a7adb0;
        }


        .line {
            border-bottom: 1px solid #a7adb0;
            height: 10px;
            width: 90%;
            position: absolute;
            bottom: 58px;
            left: 55px;

            @media screen and (max-width: 768px) {
                width: 80%;
            }
        }
    }

    .clear-button {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        color: #a7ad80 !important;
        margin: 16px 0;
    }
</style>

<style scoped>
    .sig-disabled {
        pointer-events: none !important;
    }
</style>
